import axios from "axios";

const news = axios.create({
    baseURL: process.env.VUE_APP_SUPPORT,
    timeout: 30000,
    withCredentials: true
});
news.defaults.headers['Product'] = 'vsp';

news.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

news.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    // 用户获取消息中心信息
    getListByUser(params) {
        return news.post(`/userMsgBox/listByTag/${params.tagId}`, params.param);
    },
    // 获取消息详情
    getMsgDetail(id) {
        return news.post(`/userMsgBox/readInfo/${id}`);
    },
    //  获取不同平台的消息分类
    getTagList(type) {
        return news.post(`/messageInfo/tag/getTagList/${type}`);
    },
    // 获取所有的消息列表
    getAllMsgList(obj) {
        return news.post(`/messageInfo/list/${obj.msgTag}`, obj.params);
    },
    //刪除消息
    deleteNews(ids) {
        return news.post(`/userMsgBox/delete`, ids);
    },
};